const gridTemplateColumns = {
  // 3 column grid
  "3-fixed": "repeat(3, minmax(0, 370px))",
}

module.exports = {
  gridTemplateColumns,
}

exports.default = gridTemplateColumns
